import React, { useState } from "react";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

import axios from "axios";

export default function Contact() {
  const [showForm, setShowForm] = useState(null); // 'retailer' or 'wholesaler'
  const [retailername, setretailername] = useState("");
  const [retailerphone, setretailerphone] = useState();
  const [retailerquery, setretailerquery] = useState("");
  const [wholesallername, setwholesallername] = useState("");
  const [wholesallerphone, setwholesallerphone] = useState();
  const [wholesallerquery, setwholesallerquery] = useState("");

  let handelRetailerdata = (e) => {
    e.preventDefault();

    let response = axios.post("https://kk-backend-sandy.vercel.app/retailer", {
      name: retailername,
      phone: retailerphone,
      query: retailerquery,
    });

    setretailername("");
    setretailerphone("");
    setretailerquery("");

    setShowForm(!showForm);
  };


  let handelWholesallerdata = (e) => {
    e.preventDefault();

    let response = axios.post("https://kk-backend-sandy.vercel.app/wholesaller", {
      name: wholesallername,
      phone: wholesallerphone,
      query: wholesallerquery,
    });

    setwholesallername("");
    setwholesallerphone("");
    setwholesallerquery("");

    setShowForm(!showForm);
  };


  const closeForm = () => setShowForm(null);

  return (
    <section className="text-white bg-[#011C5A] px-6 pt-36 py-16 pb-[5.7rem] relative z-10">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-12">
          <p className="text-sm font-semibold text-gray-300">Connect</p>
          <h2 className="text-3xl font-bold">Contact Us</h2>
        </div>

        {/* Contact Info */}
        <div className="flex flex-col md:flex-row justify-between gap-10 mb-16">
          {/* Email */}
          <div className="flex-1">
            <FaEnvelope className="text-2xl mb-3 text-white" />
            <h3 className="text-xl font-semibold mb-1">Email</h3>
            <a
              href="mailto:kantadevienterprises@gmail.com"
              className="text-blue-300 underline text-sm"
            >
              Kantadevienterprises@gmail.com
            </a>
          </div>

          {/* Phone */}
          <div className="flex-1">
            <FaPhoneAlt className="text-2xl mb-3 text-white" />
            <h3 className="text-xl font-semibold mb-1">Phone</h3>
            <p className="text-blue-300 text-sm underline">
               +91 8950412984
            </p>
          </div>

          {/* Location */}
          <div className="flex-1">
            <FaMapMarkerAlt className="text-2xl mb-3 text-white" />
            <h3 className="text-xl font-semibold mb-1">Location</h3>
            <a
              href="https://www.google.com/maps"
              className="text-blue-300 underline text-sm"
              target="_blank"
              rel="noreferrer"
            >
              GL-42 Ganpati Dham, Industrial Area
              <br />
              Bahadurgarh, Haryana-124507
            </a>
          </div>
        </div>

        {/* Retailer & Wholesaler Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 mb-10">
          <button
            onClick={() => setShowForm("retailer")}
            className="bg-blue-500 hover:bg-blue-700 text-white px-6 py-2 rounded text-sm font-semibold transition-all duration-300"
          >
            Contact Us - Retailer
          </button>
          <button
            onClick={() => setShowForm("wholesaler")}
            className="bg-green-500 hover:bg-green-700 text-white px-6 py-2 rounded text-sm font-semibold transition-all duration-300"
          >
            Contact Us - Wholesaler
          </button>
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-10 border-t border-gray-600 pt-10">
          {/* Logo and Links */}
          <div>
            <div className="mb-4 font-bold text-2xl">
              <img src="logo.jpg" className="w-16" alt="logo" />
            </div>
            <ul className="flex flex-wrap gap-6 text-sm text-white">
              <li>
                <a href="#">Product Range</a>
              </li>
              <li>
                <a href="#">Customer Support</a>
              </li>
              <li>
                <a href="#">About Us</a>
              </li>
              <li>
                <a href="#">Contact Us</a>
              </li>
              <li>
                <a href="#">FAQs</a>
              </li>
            </ul>
          </div>

          {/* Subscribe + Social Icons */}
          <div className="w-full md:w-1/2">
            <h4 className="text-sm font-semibold mb-2">Subscribe</h4>
            <div className="flex">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-grow px-4 py-2 rounded-l-md bg-gray-200 text-black text-sm"
              />
              <button className="bg-gray-400 text-black px-4 py-2 rounded-r-md text-sm font-semibold">
                Subscribe
              </button>
            </div>
            <p className="text-xs text-gray-300 mt-2">
              By subscribing you agree to our{" "}
              <a className="underline" href="#">
                Privacy Policy
              </a>
            </p>

            {/* Social Icons */}
            <div className="flex gap-4 mt-4">
              <a
                href="https://www.instagram.com/ksu.hinge?igsh=d3F1MzJlZXJnZXc2"
                target="_blank"
                rel="noreferrer"
                className="text-white hover:text-pink-400 text-lg"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/share/1BRfYVswqz/?mibextid=wwXIfr"
                target="_blank"
                rel="noreferrer"
                className="text-white hover:text-blue-500 text-lg"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.youtube.com/@ksuhinge"
                target="_blank"
                rel="noreferrer"
                className="text-white hover:text-red-500 text-lg"
              >
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom Links */}
        <div className="mt-10 flex flex-col md:flex-row justify-between text-xs text-gray-400 border-t border-gray-700 pt-6">
          <div className="flex flex-wrap gap-4 mb-4 md:mb-0">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Cookies Settings</a>
          </div>
          <p>© 2025 Relume. All rights reserved.</p>
        </div>
      </div>

      {/* Pop-up Form */}
      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
          <div className="bg-[#001F5C] text-black rounded-lg p-6 w-[90%] max-w-md shadow-lg relative">
            <h3 className="text-xl font-semibold mb-4 text-white text-center Manrope">
              {showForm === "retailer" ? "Retailer" : "Wholesaler"} Contact Form
            </h3>

            {showForm === "retailer" ? (
              // Retailer Form
              <form className="space-y-4 Fira">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={retailername}
                  onChange={(e) => setretailername(e.target.value)}
                  className="w-full px-4 py-2 border rounded text-sm"
                  required
                />
                <input
                  type="phone"
                  name="phone"
                  placeholder="phone"
                  value={retailerphone}
                  onChange={(e) => setretailerphone(e.target.value)}
                  className="w-full px-4 py-2 border rounded text-sm"
                  required
                />
                <textarea
                  name="query"
                  placeholder="Your Query"
                  rows="4"
                  value={retailerquery}
                  onChange={(e) => setretailerquery(e.target.value)}
                  className="w-full px-4 py-2 border rounded text-sm"
                  required
                ></textarea>
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={closeForm}
                    className="px-4 py-2 text-sm hover:bg-gray-600 hover:text-white transition-all duration-300 bg-gray-300 rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    onClick={(e) => {
                      handelRetailerdata(e);
                    }}
                    className="px-4 py-2 text-sm bg-blue-600 text-white hover:bg-blue-900 transition-all duration-300  rounded"
                  >
                    Submit
                  </button>
                </div>
              </form>
            ) : (
              // Wholesaler Form
              <form className="space-y-4 Fira">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={wholesallername}
                  onChange={(e) => setwholesallername(e.target.value)}
                  className="w-full px-4 py-2 border rounded text-sm"
                  required
                />
                <input
                  type="number"
                  name="phone"
                  value={wholesallerphone}
                  onChange={(e) => setwholesallerphone(e.target.value)}
                  placeholder="Phone"
                  className="w-full px-4 py-2 border rounded text-sm"
                  required
                />
                <textarea
                  name="query"
                  value={wholesallerquery}
                  onChange={(e) => setwholesallerquery(e.target.value)}
                  placeholder="Your Query"
                  rows="4"
                  className="w-full px-4 py-2 border rounded text-sm"
                  required
                ></textarea>
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={closeForm}
                    className="px-4 py-2 text-sm hover:bg-gray-600 hover:text-white transition-all duration-300 bg-gray-300 rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    onClick={(e) => {
                      handelWholesallerdata(e);
                    }}
                    className="px-4 py-2 text-sm bg-green-600 hover:bg-green-800 hover:text-white transition-all duration-300 text-white rounded"
                  >
                    Submit
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
